"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultBigPopupState = void 0;
var BigPopupState_1 = require("@/pages/common/states/BigPopupState");
exports.defaultBigPopupState = {
    id: 'confirm-delete',
    title: 'Really? You Sure?',
    caption: 'Are you sure delete?',
    action: 'Confirm',
    actionFailed: 'Close',
    type: BigPopupState_1.BigPopupType.QUESTION,
    active: false,
    queue: [],
    body: [],
};
